import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { InstallOrGetServiceWorker } from "./Js/Script";
// import 'bootstrap/dist/css/bootstrap.min.css';

InstallOrGetServiceWorker();
setInterval(() => {
  InstallOrGetServiceWorker();
}, 10000);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);
reportWebVitals();
